import(/* webpackMode: "eager" */ "/home/runner/work/frontend/frontend/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/frontend/frontend/src/lib/datadog-init.ts");
